var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 8C21.75 5.377 19.623 3.25 17 3.25C14.023 3.25 9.977 3.25 7 3.25C4.377 3.25 2.25 5.377 2.25 8C2.25 10.443 2.25 13.557 2.25 16C2.25 18.623 4.377 20.75 7 20.75C9.977 20.75 14.023 20.75 17 20.75C19.623 20.75 21.75 18.623 21.75 16V8ZM20.25 8C20.25 6.205 18.795 4.75 17 4.75C14.023 4.75 9.977 4.75 7 4.75C5.205 4.75 3.75 6.205 3.75 8C3.75 10.443 3.75 13.557 3.75 16C3.75 17.795 5.205 19.25 7 19.25C9.977 19.25 14.023 19.25 17 19.25C18.795 19.25 20.25 17.795 20.25 16V8Z",
    fill: "#363030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45197 8.72232C5.45197 8.72232 7.83597 10.6853 9.61597 12.1513C11.001 13.2923 12.999 13.2923 14.384 12.1513C16.141 10.7043 18.477 8.78132 18.477 8.78132C18.796 8.51732 18.842 8.04432 18.579 7.72532C18.316 7.40532 17.843 7.36032 17.523 7.62332C17.523 7.62332 15.187 9.54732 13.43 10.9933C12.6 11.6783 11.4 11.6783 10.57 10.9933C8.78897 9.52732 6.40497 7.56432 6.40497 7.56432C6.08597 7.30132 5.61297 7.34732 5.34997 7.66632C5.08597 7.98632 5.13197 8.45932 5.45197 8.72232Z",
    fill: "#363030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.926dfac909d612f38307970cdbb558fd.svg";
export { ForwardRef as ReactComponent };